import { useCallback } from 'react';
import { callDeepLink, isBrowser } from '@croquiscom/web2app';

import { useZigzag } from '@common/device-manager';
import { ZigzagEvent } from '@common/log-manager';
import {
  useCatalogProductIdParams,
  useGetPdpIntegratedData,
  usePdpBaseInfo,
  useProductReviewTotalCount,
} from '@domains/pdp-common';

export const useRatingsService = () => {
  const params = useCatalogProductIdParams();

  const { product, shop } = usePdpBaseInfo(params);
  const { review_total_count } = useProductReviewTotalCount(params.catalog_product_id);
  const { related_product_review_summary } = useGetPdpIntegratedData({ catalog_product_id: params.catalog_product_id });
  const ratings_average = Math.floor((related_product_review_summary?.ratings_average ?? 0) * 10) / 10;
  const is_in_app = useZigzag();
  const is_browser = isBrowser();
  const is_hide = !review_total_count;

  const handleClickViewAll = useCallback(() => {
    ZigzagEvent.subl({
      category: 'click',
      navigation: 'product_detail',
      object_section: 'subtab_description',
      object_type: 'button',
      object_id: 'review_all',
    });

    callDeepLink('/browser_product_review')({
      shop_main_domain: shop.main_domain,
      product_id: product.id,
    });
  }, [shop.main_domain, product.id]);

  return {
    handleClickViewAll,
    review_count: review_total_count,
    ratings_average,
    is_in_app,
    is_browser,
    is_hide,
    product_id: params.catalog_product_id,
  };
};
